import React from 'react';
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { getControlTokens } from './controlTokens';

function ControlGroup({
  context = 'filterBar',
  align = 'end',
  wrap = false,
  children,
  sx,
}) {
  const theme = useTheme();
  const tokens = getControlTokens(theme, context);

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: align === 'start' ? 'flex-start' : align === 'center' ? 'center' : 'flex-end',
        flexWrap: wrap ? 'wrap' : 'nowrap',
        gap: tokens.gap,
        maxWidth: '100%',
        minWidth: 0,
        overflowX: wrap ? 'visible' : 'auto',
        overflowY: 'hidden',
        scrollbarWidth: 'none',
        '&::-webkit-scrollbar': { display: 'none' },
        '& > *': { flex: '0 0 auto' },
        ...sx,
      }}
    >
      {children}
    </Box>
  );
}

export default ControlGroup;

